import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .twyla-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];
    }

    .first-figure {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .header-wrapper {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .paragraphs-wrapper {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .second-figure {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    figure {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      margin: 0;
    }

    figure > img {
      padding: calc(20rem / var(--default-rem-px-count));
      border: 1px solid #979797;
    }

    h2 {
      text-wrap: balance;
    }

    .image-caption {
      padding-top: 1em;
      border-top: 1px solid #c0c0c0;
      display: flex;
      justify-content: space-between;
    }

    .image-caption > span > p {
      font-size: 0.825em;
      line-height: 1.25em;
      margin: 0;
    }

    .image-caption > span > a {
      cursor: pointer;
    }

    .header-wrapper {
      display: flex;
      flex-direction: column;
    }

    .paragraphs-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .twyla-layout {
        grid-template-rows:
          var(--top-padding-height)
          1fr
          1fr
          1fr
          var(--bottom-padding-height);
      }

      .first-figure {
        grid-column: 2 / 8;
        grid-row: 2 / 4;
      }

      .header-wrapper {
        grid-column: 9 / 14;
        grid-row: 2 / 3;
      }

      .paragraphs-wrapper {
        grid-column: 2 / 8;
        grid-row: 4 / 5;
      }

      .second-figure {
        grid-column: 8 / 14;
        grid-row: 3 / 5;
      }

      .header-wrapper {
        align-self: center;
      }

      .header-wrapper > h2 {
        max-width: 60%;
      }

      .paragraph {
        flex: 1;
        text-wrap: pretty;
      }

      .header-wrapper {
        flex-direction: row;
        justify-content: space-between;
      }

      .cta-wrapper {
        align-self: center;
      }
    }

    @media (min-width: 1024px) {
      .paragraphs-wrapper {
        flex-direction: row;
        align-self: center;
        padding-top: 0;
      }
    }
  `,
];
